const React = require("react");
const createReactClass = require("create-react-class");
const OfficeModal = require("./OfficeModal");
const {ErrorIcon} = require("../../core/view/ErrorIcon");
const withVaultUpdate = require("../../core/hoc/withVaultUpdate");
const CopyTable = require("../data/CopyTable");
const CoreCopy = require("../../core/util/CopyTable");
const URLMake = require("../../../shared/URLMake");

const styles = require("./styles/ErrorModal.css");

const checkoutErrorCopy = CopyTable.getCheckoutErrorCopy();

// Helper to apply higher-order components.
const augment = function(Component) {
	Component = withVaultUpdate(Component);
	return Component;
};
module.exports = augment(
	createReactClass({
		displayName: "ErrorModal",

		// Used by vault update HOC
		vaultEvents: {
			cartNotFound: function() {
				this.showCheckoutError("cartNotFound");
			},
			cartCheckedOut: function() {
				this.showCheckoutError("cartCheckedOut");
			},
			orderInProgress: function() {
				this.showCheckoutError("orderInProgress");
			},
			mustRedoCheckout: function() {
				this.showCheckoutError("mustRedoCheckout");
			},
			mustRedoCheckoutPriceMismatch: function() {
				this.showCheckoutError("mustRedoCheckoutPriceMismatch");
			},
			prepareOrderNotReady: function() {
				this.showCheckoutError("prepareOrderNotReady");
			},
			placeOrderNotReady: function() {
				this.showCheckoutError("placeOrderNotReady");
			},
			checkoutFieldsError: function(step, fields) {
				if (step === "billing") {
					if (fields && fields.creditCard) {
						const field = fields.creditCard[0];

						if (field === "number") {
							this.showCheckoutError("cardInvalid", true);
						} else if (field === "exp") {
							this.showCheckoutError("cardInvalidExp", true);
						} else {
							this.showCheckoutError("billingFieldError", true);
						}
					} else {
						this.showCheckoutError("billingFieldError", true);
					}
				} else if (step === "shipping") {
					this.showCheckoutError("shippingFieldError", true);
				} else if (step === "paypalinfo") {
					this.showCheckoutError("paypalInfoFieldError", true);
				}
			},
			prepareOrderFail: function() {
				this.showCheckoutError("prepareOrderFail");
			},
			prepareOrderTaxCloudFail: function() {
				this.showCheckoutError("prepareOrderTaxCloudFail");
			},
			prepareOrderZipCodeFail: function() {
				this.showCheckoutError("prepareOrderZipCodeFail");
			},
			placeOrderFail: function() {
				this.showCheckoutError("placeOrderFail");
			},
			cvvMismatch: function() {
				this.showCheckoutError("cvvMismatch");
			},
			cardTypeNotSupported: function() {
				this.showCheckoutError("cardTypeNotSupported");
			},
			captchaUnanswered: function() {
				this.showCheckoutError("captchaUnanswered");
			},
			placeOrderUnknown: function() {
				this.showCheckoutError("placeOrderUnknown");
			},
			placeOrderCritical: function() {
				this.showCheckoutError("placeOrderCritical");
			},
			placeOrderDuplicate: function() {
				this.showCheckoutError("placeOrderDuplicate");
			},
			checkoutServerTimeout: function() {
				this.showCheckoutError("checkoutServerTimeout");
			},
			multipleFailedCheckouts: function() {
				this.showCheckoutError("multipleFailedCheckouts");
			},
			cardDeclined: function() {
				this.showCheckoutError("cardDeclined", true);
			},
			cardInvalid: function() {
				this.showCheckoutError("cardInvalid", true);
			},
			startPaypalFail: function() {
				this.showCheckoutError("startPaypalFail");
			},
			paypalRetry: function() {
				this.showCheckoutError("paypalRetry");
			},
			paypalReset: function() {
				this.showCheckoutError("paypalReset");
			},
			couponNoLongerValid: function() {
				this.showCheckoutError("couponNoLongerValid");
			},
			couponOutOfDate: function() {
				this.showCheckoutError("couponOutOfDate");
			},
			changeSubscriptionFail: function(reason) {
				const errorType =
					reason === "cardExpired" ? "cardExpired" : "changeSubscriptionFail";
				this.showCheckoutError(errorType);
			},
			changeSubscriptionTooFarOut: function() {
				this.showCheckoutError("changeSubscriptionTooFarOut");
			},
			changeSubscriptionStudentExists: function() {
				this.showCheckoutError("changeSubscriptionStudentExists");
			},
			changeSubscriptionPriceFail: function() {
				this.showCheckoutError("changeSubscriptionPriceFail");
			},
			changeSubscriptionInvalid: function() {
				this.showCheckoutError("changeSubscriptionInvalid");
			},
			changeSubscriptionUnknown: function() {
				this.showCheckoutError("changeSubscriptionUnknown");
			},
			cancelSubscriptionFail: function() {
				this.showCheckoutError("cancelSubscriptionFail");
			},
			cancelSubscriptionInvalid: function() {
				this.showCheckoutError("cancelSubscriptionInvalid");
			},
			cancelSubscriptionUnknown: function() {
				this.showCheckoutError("cancelSubscriptionUnknown");
			},
			officeParentError: function(error, opts) {
				this.showParentError(error, opts);
			},
			sessionExpired: function() {
				this.setState({
					isOpen: true,
					text: CoreCopy.forSessionExpired(),
					buttonType: "login",
				});
			},
		},

		showCheckoutError: function(errorType, isWarning) {
			const errorText =
				checkoutErrorCopy[errorType] || checkoutErrorCopy.default;
			this.setState({isOpen: true, text: errorText, isWarning: isWarning});
		},

		showTeacherError: function(error) {
			const errorText = CopyTable.getTeacherErrorCopy(error);
			this.setState({isOpen: true, text: errorText});
		},

		showParentError: function(error, opts = {}) {
			this.setState({
				isOpen: true,
				text: CopyTable.getParentErrorCopy(error),
				buttonType: opts.needsReload ? "refresh" : "okay",
				isWarning: opts.isWarning || false,
			});
		},

		getInitialState: function() {
			return {
				isOpen: false,
				isWarning: false,
				text: "",
				buttonType: "okay",
			};
		},

		onClose: function() {
			this.setState({isOpen: false});
		},

		onRefresh: function() {
			window.location.reload();
		},

		onLogin: function() {
			window.location.href = URLMake.forLogin();
		},

		renderButton: function() {
			const {buttonType} = this.state;
			let onClick = this.onClose;
			let text = "Okay";
			if (buttonType === "refresh") {
				onClick = this.onRefresh;
				text = "Refresh";
			} else if (buttonType === "login") {
				onClick = this.onLogin;
				text = "Sign in";
			}
			return (
				<div className={styles.button} onClick={onClick}>
					{text}
				</div>
			);
		},

		render: function() {
			if (this.state.isOpen) {
				return (
					<OfficeModal
						onClose={this.onClose}
						closeOnEsc={true}
						portalContainer={null}
						level="warning"
						modalClass={styles.main}
					>
						<div className={styles.container}>
							<div className={styles.aboveButton}>
								<ErrorIcon isWarning={this.state.isWarning} />
								<div className={styles.message}>{this.state.text}</div>
							</div>
							{this.renderButton()}
						</div>
					</OfficeModal>
				);
			} else {
				return null;
			}
		},
	})
);
